import { IconProps } from '../Icons.type'

export function ArrowUpIcon(props: IconProps) {
  return (
    <svg
      width="8"
      height="9"
      viewBox="0 0 8 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M3.99864 0.500555C3.87483 0.499949 3.75082 0.550626 3.66176 0.652562L0.555078 4.20812C0.393572 4.39296 0.412489 4.67373 0.597331 4.83523C0.782172 4.99674 1.06294 4.97782 1.22445 4.79298L3.55643 2.12406V8.0561C3.55643 8.30156 3.75541 8.50055 4.00087 8.50055C4.24633 8.50055 4.44532 8.30156 4.44532 8.0561V2.13165L6.77771 4.79345C6.93948 4.97807 7.22028 4.99659 7.40489 4.83482C7.5895 4.67305 7.60802 4.39226 7.44626 4.20764L4.36868 0.695414C4.28871 0.577802 4.15382 0.50055 4.00087 0.50055L3.99864 0.500555Z"
        fill="currentColor"
      />
    </svg>
  )
}
